// Shared helpers for deep-linking a thread into the full AI chat page (`/ai-chat?threadId=<id>`).
// Kept in a standalone module so the floating panel's Expand control can build the same URL
// without importing the lazy-loaded AiChatPage into the always-mounted layout bundle.

export const THREAD_ID_QUERY_PARAM = 'threadId';

export const parseRequestedThreadId = (rawThreadId: string | null): number | null => {
    if (rawThreadId == null || !/^\d+$/.test(rawThreadId)) {
        return null;
    }

    const parsedThreadId = Number(rawThreadId);
    if (!Number.isSafeInteger(parsedThreadId) || parsedThreadId <= 0) {
        return null;
    }

    return parsedThreadId;
};

export const buildAiChatPath = (nextThreadId?: number | null): string => {
    // Only serialize ids that parseRequestedThreadId would accept back (positive safe integers),
    // so Expand never produces a link the page immediately scrubs as invalid.
    if (nextThreadId == null || !Number.isSafeInteger(nextThreadId) || nextThreadId <= 0) {
        return '/ai-chat';
    }

    return `/ai-chat?${THREAD_ID_QUERY_PARAM}=${nextThreadId}`;
};
